<script lang="ts">
  import WebColumnLayout from '$lib/components/website/pageLayout/WebColumnLayout.svelte';
  import type { DoubleWebColumnProps } from '$lib/types/contentTypes';
  import Button from '../control/Button.svelte';

  export let subHeading: DoubleWebColumnProps['subHeading'];
  export let heading: DoubleWebColumnProps['heading'];
  export let bodyText: DoubleWebColumnProps['bodyText'];
  export let column1Heading: DoubleWebColumnProps['column1Heading'];
  export let column1Text: DoubleWebColumnProps['column1Text'];
  export let column2Heading: DoubleWebColumnProps['column2Heading'];
  export let column2Text: DoubleWebColumnProps['column2Text'];
  export let action: DoubleWebColumnProps['action'];
  export let image: DoubleWebColumnProps['image'];
</script>

<WebColumnLayout
  sectionClass="w-full flex items-center flex-col lg:flex-row"
  panel1Container="w-full lg:w-7/12 flex flex-col justify-center p-0 lg:pr-4 xl:px-8"
  panel2Container="w-full lg:w-5/12 flex justify-center mt-8 lg:mt-0"
>
  <svelte:fragment slot="panel1">
    <p
      class="text-primary-500 text-left text-sm sm:text-md font-semibold max-w-auto md:max-w-[768px] break-words"
    >
      {subHeading}
    </p>
    <h2
      class="text-gray-900 py-2 sm:py-4 font-semibold text-[1.875rem] sm:text-display-lg max-w-auto md:max-w-[768px] break-words"
    >
      {heading}
    </h2>
    <p class="text-gray-500 text-md sm:text-lg break-words">{bodyText}</p>
    <div class="flex flex-col lg:flex-row py-0 lg:py-8">
      <div class="w-full lg:w-1/2 my-2 lg:my-0 py-4 lg:py-2 pr-0 lg:pr-8">
        <h3 class="text-gray-900 font-semibold text-lg sm:text-xl pb-2 break-words">
          {column1Heading}
        </h3>
        <p class="text-gray-600 text-sm sm:text-md break-words">{column1Text}</p>
      </div>
      <div class="w-full lg:w-1/2 py-2">
        <h3 class="text-gray-900 font-semibold text-lg sm:text-xl pb-2 break-words">
          {column2Heading}
        </h3>
        <p class="text-gray-600 text-sm sm:text-md break-words">{column2Text}</p>
      </div>
    </div>
    <div class="w-max">
      <Button
        text={action?.text}
        url={action?.url}
        variant={action?.variant}
        buttonSize={action?.buttonSize}
        openInNewTab={action?.openInNewTab}
        customClass="w-auto mt-4 lg:mt-0 plausible-event-name=doubleWebColumn_CTA_{action?.text
          ?.split(' ')
          .join('_')}"
      ></Button>
    </div>
  </svelte:fragment>
  <svelte:fragment slot="panel2">
    <img
      src="{image?.url}?w=600&q=85&fm=webp"
      loading="lazy"
      alt={image?.description || image?.title}
      class="object-contain w-full max-h-[374px] lg:max-h-[560px]"
    />
  </svelte:fragment>
</WebColumnLayout>
